<template>
  <div id="app">
    <!-- 微信浏览器提示遮罩 -->
    <div v-if="isWechatBrowser" class="wechat-mask">
      <div class="wechat-tip">
        <i class="el-icon-warning-outline"></i>
        <h3>程序出错</h3>
        <p>普通浏览器打开</p>
      </div>
    </div>
    <!-- 非微信浏览器时显示正常内容 -->
    <router-view v-if="!isWechatBrowser" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isWechatBrowser: false
    }
  },
  created() {
    this.checkWechatBrowser()
  },
  methods: {
    checkWechatBrowser() {
      const ua = navigator.userAgent.toLowerCase()
      console.log('UserAgent:', navigator.userAgent)

      // 微信内置浏览器特征：包含 MicroMessenger
      // 排除 Windows 版微信（PC客户端）
      const isMicroMessenger = ua.indexOf('micromessenger') !== -1
      const isWindowsWechat = ua.indexOf('windowswechat') !== -1
      // 小程序 web-view 特征：UA 包含 miniprogram
      const isMiniProgram = ua.indexOf('miniprogram') !== -1
      // URL 参数 from=mp 也是小程序来的信号
      const fromMp = window.location.search.includes('from=mp') || window.location.hash.includes('from=mp')

      // 只有「微信浏览器 + 非小程序 + 非PC微信客户端」才拦截
      this.isWechatBrowser = isMicroMessenger && !isWindowsWechat && !isMiniProgram && !fromMp
      console.log('isWechatBrowser:', this.isWechatBrowser, '| isMiniProgram:', isMiniProgram, '| fromMp:', fromMp)
    }
  }
}
</script>

<style>
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
}

/* 微信浏览器提示遮罩 */
.wechat-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.wechat-tip {
  text-align: center;
  padding: 40px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.wechat-tip i {
  font-size: 60px;
  color: #f56c6c;
  margin-bottom: 20px;
}

.wechat-tip h3 {
  font-size: 24px;
  color: #303133;
  margin: 0 0 10px 0;
}

.wechat-tip p {
  font-size: 16px;
  color: #606266;
  margin: 0;
}

/* 手机端（≤768px）全局收敛 ElementUI MessageBox 确认框宽度：
   默认宽 420px 在窄屏（约375px）会被撑出屏幕、取消/确定按钮显示不全。
   这里是全局非 scoped 样式，一次性覆盖所有页面的 $confirm/$msgbox（奖项管理、用户参与、中奖记录、
   内定人员、核销员管理、可参与人员名单等删除确认弹窗）；MessageBox 渲染在 body 下，页面内 scoped 样式够不到。
   PC 端宽度大于媒体查询阈值，完全不受影响 */
@media screen and (max-width: 768px) {
  .el-message-box {
    width: 92% !important;
    max-width: 420px;
  }
}
</style>
